import React from 'react';
import { createRoot } from 'react-dom/client';
import OpsVoiceWidget from './OpsVoiceWidget';

const container = document.getElementById('root');
const root = createRoot(container);
root.render(
  <React.StrictMode>
    <OpsVoiceWidget />
  </React.StrictMode>
);
